enum VendorCustomerOnboardingStateEnum {
  RegistrationToSend = "RegistrationToSend",
  RegistrationSent = "RegistrationSent",
  Registered = "Registered",
  Onboarded = "Onboarded",
}

export default VendorCustomerOnboardingStateEnum;
